import React from 'react';
import Cookies from 'js-cookie';
import RawHTML from '~/components/jsx-helpers/raw-html';
export default function ContentWarning({ link, track, close, onDownload, variant, warning, id }) {
    const closeAfterDelay = React.useCallback((event) => {
        const key = cookieKey(id);
        if (onDownload) {
            onDownload(event);
        }
        Cookies.set(key, 'true', { expires: 28 });
        window.setTimeout(close, 200);
    }, [close, onDownload, id]);
    return (React.createElement("div", { className: "give-before-pdf" },
        React.createElement("div", { className: "text-content" },
            React.createElement(RawHTML, { html: warning })),
        React.createElement("a", Object.assign({ href: link }, (track ? { 'data-track': track } : {}), { onClick: closeAfterDelay, className: "btn go-to" }),
            "Go to your ",
            variant === 'View online' ? 'book' : 'file')));
}
function cookieKey(id) {
    return `content-warning-${id}`;
}
export function checkWarningCookie(id) {
    return Cookies.get(id);
}
